export default function ({ store, app }) {
    if (app.$auth.loggedIn) {
        store.dispatch('portal/initializeStore')
    }
}

